import _flow from 'lodash/flow'
import _sortBy from 'lodash/sortBy'
import { createFilterOption } from 'frontend/helpers/filterSelectorUtils'
import { listStandardProductionConfigurations } from 'frontend/communications/standards'

const stateObj = {
  standardProductionConfigurations: [],
}

const getters = {
  areStandardProductionConfigurationsActive (state) {
    return state.standardProductionConfigurations.some(level => level.enabled)
  },
  getSelectorStandardProductionConfigurationsOptions: (state) => (including=[]) => {
    return _flow([
      () => state.standardProductionConfigurations.filter(level => including.includes(level.id) || level.enabled),
      items => items.map(level => {
        return createFilterOption({
          text: level.name,
          value: level.id,
          checked: false,
        })
      }),
      items => _sortBy(items, 'text'),
    ])()
  },
  getStandardProductionConfigurations (state) {
    return _sortBy(state.standardProductionConfigurations.filter(conf => conf.enabled), 'name')
  },
  getStandardProductionConfigurationsById: (state) => (id) => {
    return state.standardProductionConfigurations.find(ergLvl => ergLvl.id === id)
  },
}

const mutations = {
  setStandardProductionConfigurations (state, levels) {
    state.standardProductionConfigurations = levels
  },
}

const actions = {
  fetchStandardProductionConfigurations ({ commit }) {
    return listStandardProductionConfigurations().then(levels => {
      commit('setStandardProductionConfigurations', levels)
      return levels
    })
  },
}

export default {
  getters,
  mutations,
  state: stateObj,
  actions,
}
